import { LandingsPage } from "./LandingsPage";
export default LandingsPage;
